<template>
  <v-container>
    <div>
      <v-row dense class="mt-9" v-if="loading" alig="center" justify="center">
        <v-progress-circular indeterminate></v-progress-circular>
      </v-row>
      <div dense class="mt-9" v-else>
        <div v-if="needsMatch">
          <v-row dense class="mt-9">
            <v-row dense>
              <v-col>
                <v-card
                  elevation="1"
                  style="
                    border-radius: 10px;
                    position: relative;
                    overflow: visible;
                  "
                >
                  <v-card-text>
                    <v-row dense style="padding: 2vh">
                      <v-col cols="12" md="10">
                        <div
                          class="d-flex align-start justify-start flex-column"
                        >
                          <span class="header mb-4">Minhas turmas</span>
                          <span>{{ subText }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="2" class="image-col"> </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-row>
          <div dense class="mt-9" v-if="needsMatch">
            <v-row>
              <v-col
                v-for="(teacher, subIndex) in matchingGroups"
                :key="subIndex"
                cols="12"
                md="4"
              >
                <MatchedPartnerCard
                  :item="teacher.teacher"
                  :limit="limit"
                  @requestJoin="sendRequestToTeacher"
                />
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-col
              cols="12"
              class="d-flex align-center justify-center flex-column"
            >
              <span class="text-h4 bolder--text"
                >Que pena nenhum professor disponível</span
              >
              <small class="text-h6"
                >Não se preocupe, te avisaremos assim que um professor estiver
                disponível 😉</small
              >
            </v-col>
          </div>
        </div>
        <div v-else>
          <v-row dense class="mt-9">
            <v-row dense>
              <v-col>
                <v-card
                  elevation="1"
                  style="
                    border-radius: 10px;
                    position: relative;
                    overflow: visible;
                  "
                >
                  <v-card-text>
                    <v-row dense style="padding: 2vh">
                      <v-col cols="12" md="10">
                        <div
                          class="d-flex align-start justify-start flex-column"
                        >
                          <span class="header mb-4">Minhas turmas</span>
                          <span
                            >Seja bem-vindo, verifique as turmas nas quais você
                            participa 🥳</span
                          >
                        </div>
                      </v-col>
                      <v-col cols="12" md="2" class="image-col"> </v-col>
                    </v-row>
                    <div dense class="mt-9">
                      <v-row
                        v-for="(item, index) in data"
                        :key="index"
                        class="mt-4"
                      >
                        <ClassView :item="item" />
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-row>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import customerApi from "@/shared/pitchCustomerApi";
import ClassView from "@/components/connect/customer/ClassView.vue";
import MatchedPartnerCard from "@/components/connect/partner/MatchedPartnerCard.vue";

export default {
  name: "CustomerClasses",
  components: { MatchedPartnerCard, ClassView },
  async created() {
    await customerApi
      .groups()
      .then((groups) => {
        if (groups.data.count === 0) {
          this.needsMatch = true;
          customerApi.doAMatch().then((res) => {
            this.matchingGroups = res.data.matched;
            this.limit = res.data.limit;
            this.loading = false;
          });
        } else {
          this.data = groups.data.data.data;
          this.count = groups.data.count;
          this.loading = false;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  data() {
    return {
      limit: 0,
      needsMatch: false,
      count: 0,
      data: [],
      loading: true,
      subText:
        "Você ainda não faz parte de uma turma,  escolha uma logo abaixo e bons estudos! ",
      matchingGroups: [],
    };
  },
  methods: {
    async sendRequestToTeacher(item) {
      await customerApi
        .requestJoin({ partnerId: item.id, hours: item.hours })
        .then((res) => {
          this.$root.$emit("display-alert", {
            text: res.data.message + " 😊",
            type: 0,
          });
        })
        .catch((err) => {
          if (err.response.data.statusCode === 400) {
            this.$root.$emit("display-alert", {
              text: err.response.data.message,
              type: 1,
            });
          } else
            this.$root.$emit("display-alert", {
              text: "Algo deu errado durante a solicitação para juntar-se a turma 🥺",
              type: 1,
            });
        });
    },
  },
};
</script>

<style lang="css" scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}
</style>
